jQuery(window).load(function () {



});
jQuery(document).ready(function($){
    $('#partners-slider').multislider({
        duration:3500,
        continuous: true
    });

});
